// Consent purpose codes per ConsentAuditLog schema.
// UI renders descriptive labels; codes remain the canonical identifiers
// used by ConsentAuditLog and consent storage.
// Per DESIGN-DECISIONS-2026-05-01.md §Q8.

export const CONSENT_LABELS = {
  P1: "Care Coordination",
  P2: "Health Passport",
  P3: "Monthly Report",
  P4: "AI Training",
} as const;

export type ConsentPurposeCode = keyof typeof CONSENT_LABELS;

/**
 * Render a consent purpose code as its descriptive label.
 * Returns the code itself for unknown values (defensive).
 */
export function consentLabel(code: string): string {
  return (CONSENT_LABELS as Record<string, string>)[code] ?? code;
}
